import { ReactNode } from '@tanstack/react-router'

import { useLocalisation } from '@/utils/localisation'

import { ExtendedSurveyResponse } from '../../domain/survey/surveyQuestionProps'

export const useRenderTranslationKey = () => {
  const { translate } = useLocalisation()
  return (key: string, params?: Record<string, unknown>): string => {
    const term = `survey.mot.${key}`
    // @ts-expect-error In some cases props.translationKey are from BE models
    return translate(term, params || undefined)
  }
}

export const useRenderSurveyText = (): { render: (extendedSurveyResponse: ExtendedSurveyResponse) => ReactNode } => {
  const renderTranslationKey = useRenderTranslationKey()

  return {
    render: ({ id, translationKey, render }: ExtendedSurveyResponse) => {
      if (render) {
        return render({ id, translationKey })
      }
      return renderTranslationKey(translationKey)
    },
  }
}
